import type { FrequencyModel } from '../app/types/account-category.type.ts';
import baseApi from './meeting-md-api-slice';

const frequencyApiSlice = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchFrequencies: builder.query<FrequencyModel[], void>({
      query() {
        return `/frequency`;
      },
    }),
  }),
});

export const { useFetchFrequenciesQuery } = frequencyApiSlice;
